/**
 * Shows a product image on the default variant of the sign-up modal.
 */
export const SIGNUP_MODAL_DEFAULT_VARIANT_IMAGERY_240806 = 'SIGNUP_MODAL_DEFAULT_VARIANT_IMAGERY_240806';
